import { VisualEditorType } from "../Types"
import { MainThunkDispatch } from "../../Reducers"
import { failMessage } from "../Client/MessagesActions"
import { apiEndpoints } from "../../Routes/api"
import { apiFetch } from "../Client/NetworkActions"

import { APIAppTemplateSchemaModel } from "../../Models/API/AppTemplateModel"
// import { DocumentExtraction } from "universal-schema/lib/1.0.0/document-schema"
import { DocumentType } from "../../Models/DataProgram/DocumentExtraction"
// import { outputMock } from "../../../../Components/Views/Store/Sections/Onboarding/Stages/SetParameters/DocumentsExtraction/mock"

export const getDetectedAnnotations =
    (doc: DocumentType) => async (dispatch: MainThunkDispatch) => {
        try {
            dispatch({
                type: VisualEditorType.detectAnnotations
            })
            // const endpoint = apiEndpoints.getDetectedAnnotations({})
            // const data = await dispatch(
            //     apiFetch<{ item: DocumentExtraction }>(endpoint.url, endpoint)
            // )
            // if (data === undefined) {
            //     return
            // }

            dispatch({
                type: VisualEditorType.receivedDetectedAnnotations
                // payload: outputMock as DocumentExtraction // TODO: remove mock
            })
        } catch (error) {
            dispatch(failMessage("Could not detect annotations", error))
            dispatch({
                type: VisualEditorType.receivedDetectionErrors
            })
            throw error
        }
    }

export const getOnboardingAppSchema =
    (params: { templateName: string; appParams: any }) =>
    async (dispatch: MainThunkDispatch) => {
        try {
            dispatch({
                type: VisualEditorType.getAppSchema
            })
            const endpoint = apiEndpoints.getAppSchema({})
            const data = await dispatch(
                apiFetch<APIAppTemplateSchemaModel>(endpoint.url, endpoint, {
                    method: "POST",
                    body: JSON.stringify(params)
                })
            )

            if (data === undefined) {
                return
            }

            dispatch({
                type: VisualEditorType.setAppSchema,
                payload: data
            })
        } catch (error) {
            dispatch(failMessage("Could not get app schema", error))
            dispatch({
                type: VisualEditorType.setAppSchemaErrors,
                payload: "Could not get app schema"
            })
            throw error
        }
    }
